
import React from "react";
import { motion } from "framer-motion";
import PuttingTestsSection from "./selector/PuttingTestsSection";
import ChippingTestsSection from "./selector/ChippingTestsSection";
import WedgingTestsSection from "./selector/WedgingTestsSection";
import BunkerTestsSection from "./selector/BunkerTestsSection";
import IronTestsSection from "./selector/IronTestsSection";
import DriverTestsSection from "./selector/DriverTestsSection";
import FairwayWoodTestsSection from "./selector/FairwayWoodTestsSection";
import { useTestTranslations } from "@/hooks/useTestTranslations";

interface Test {
  id: string;
  title: string;
  description: string;
  icon: string;
}

interface TestSelectorProps {
  puttingTests: Test[];
  chippingTests: Test[];
  wedgingTests: Test[];
  bunkerTests: Test[];
  ironTests: Test[];
  fairwayWoodTests: Test[];
  driverTests: Test[];
  onSelectTest: (testId: string) => void;
}

const TestSelector: React.FC<TestSelectorProps> = ({ 
  puttingTests, 
  chippingTests, 
  wedgingTests,
  bunkerTests,
  ironTests,
  fairwayWoodTests,
  driverTests,
  onSelectTest 
}) => {
  const { translateTests } = useTestTranslations();
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="mb-12"
    >
      <PuttingTestsSection 
        puttingTests={translateTests(puttingTests, 'putting')} 
        onSelectTest={onSelectTest} 
      />
      
      <ChippingTestsSection 
        chippingTests={translateTests(chippingTests, 'chipping')} 
        onSelectTest={onSelectTest} 
      />
      
      <WedgingTestsSection 
        wedgingTests={translateTests(wedgingTests, 'wedging')} 
        onSelectTest={onSelectTest} 
      />
      
      <BunkerTestsSection 
        bunkerTests={translateTests(bunkerTests, 'bunker')} 
        onSelectTest={onSelectTest} 
      />
      
      <IronTestsSection 
        ironTests={translateTests(ironTests, 'iron')}
        fairwayWoodTests={translateTests(fairwayWoodTests, 'fairwayWood')}
        onSelectTest={onSelectTest} 
      />

      <DriverTestsSection 
        driverTests={translateTests(driverTests, 'driver')} 
        onSelectTest={onSelectTest} 
      />
    </motion.div>
  );
};

export default TestSelector;
